module.exports = __webpack_public_path__ + "static/img/1-Projectile motion@2x.c1d847f6.png";